import moment from "moment";
import { JobRole } from "shared/utils/enum";
import * as XLSX from "xlsx-js-style";

const $PRIMARY = "404040",
  $LIGHT_PRIMARY = "fdf3d0",
  $BLACK = "000000",
  $FONT_COLOR = "FFBE1D",
  $WHITE = "ffffff";

export const exportToExcel = (data: any) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const date = moment(new Date()).format("MMMM DD, YYYY");

  let allRows = [];

  let firstRow = [
    {
      v: "Role Assessment Score (RAS) System ― Job Evaluations Download",
      t: "s",
      s: {
        font: { name: "Arial Nova", bold: true, sz: 12 },
        alignment: { wrapText: false, horizontal: "left" },
      },
    },
  ];

  let secondRow = [
    {
      v: "Company Name:",
      t: "s",
      s: {
        font: { name: "Arial Nova", bold: false, sz: 11 },
        alignment: { wrapText: false, horizontal: "left" },
      },
    },
    {
      v: data?.orgName,
      t: "s",
      s: {
        font: { name: "Arial Nova", bold: false, sz: 11 },
        alignment: { wrapText: false, horizontal: "left" },
      },
    },
  ];

  let thirdRow = [
    {
      v: "Download Date:",
      t: "s",
      s: {
        font: { name: "Arial Nova", bold: false, sz: 11 },
        alignment: { wrapText: false, horizontal: "left" },
      },
    },
    {
      v: date,
      t: "s",
      s: {
        font: { name: "Arial Nova", bold: false, sz: 11 },
        alignment: { wrapText: false, horizontal: "left" },
      },
    },
  ];

  let topRow = [
    {
      v: "Job Title",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          left: { color: { rgb: $WHITE } },
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Department",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Job Code",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Job Grade",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Role Type",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Level of Work",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Level of Work Modifier",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Level of Work Points",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Knowledge & Skill",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Working Environment",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Application of Knowledge & Skill",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Manual Effort",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Outcomes",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Notes",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "RAS Score",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "RAS Level",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "RAS Code",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Evaluated By",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Evaluations Date",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
  ];

  let headRow = [
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Institutional Expertise & Scope",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
          top: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Cultural Impact",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
          top: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "External Environment",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
          top: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "Mental and Emotional Environment",
      t: "s",
      s: {
        font: {
          name: "Arial Nova",
          bold: true,
          sz: 11,
          color: { rgb: $FONT_COLOR },
        },
        alignment: { wrapText: true, horizontal: "center", vertical: "center" },
        border: {
          right: { color: { rgb: $WHITE } },
          top: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
    {
      v: "",
      t: "",
      s: {
        border: {
          right: { color: { rgb: $WHITE } },
        },
        fill: { fgColor: { rgb: $PRIMARY } },
      },
    },
  ];
  allRows.push(firstRow);
  allRows.push(secondRow);
  allRows.push(thirdRow);
  allRows.push([]);
  allRows.push(topRow);
  allRows.push(headRow);

  let dataRow = [
    {
      v: data?.jobTitle,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "left" },
        border: {
          left: { color: { rgb: $BLACK } },
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: data?.department,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "left" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: data?.jobeCode,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "left" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: data?.jobGrade ? data?.jobGrade : "N/A",
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v:
        data?.roleType === JobRole.management
          ? "Manager"
          : "Individual Contributor",
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "left" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: data?.level_of_work?.short_des,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "left" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: data?.modifier,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: data?.modifierScore,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: `${data?.q2?.level} (${data?.q2?.score})`,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: `${data?.q3?.level} (${data?.q3?.score})`,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: `${data?.q4?.level} (${data?.q4?.score})`,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: `${data?.q5?.level} (${data?.q5?.score})`,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: `${data?.q6?.level} (${data?.q6?.score})`,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: `${data?.q7?.level} (${data?.q7?.score})`,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: `${data?.q8?.level} (${
        data?.roleType === JobRole.management
          ? data?.outcomeScore
          : data?.q8?.score
      })`,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: data?.q9 ? data?.q9 : "N/A",
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: data?.rasScore,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11, italic: true },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
        fill: { fgColor: { rgb: $LIGHT_PRIMARY } },
      },
    },
    {
      v: data?.rasLevel,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11, italic: true },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
        fill: { fgColor: { rgb: $LIGHT_PRIMARY } },
      },
    },
    {
      v: data?.shortCode,
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11, italic: true },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
        fill: { fgColor: { rgb: $LIGHT_PRIMARY } },
      },
    },
    {
      v:
        data?.evaluated_by?.name && data?.fromAdmin
          ? `CGP (${data?.evaluated_by?.name})`
          : data?.evaluated_by?.name
          ? data?.evaluated_by?.name
          : "CGP",
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
    {
      v: moment(
        new Date(data?.created_at).toLocaleDateString("en-US", options)
      ).format("DD-MMM-YY"),
      t: "s",
      s: {
        font: { name: "Arial Nova", sz: 11 },
        alignment: { wrapText: true, horizontal: "center" },
        border: {
          right: { color: { rgb: $BLACK } },
          bottom: { color: { rgb: $BLACK } },
        },
      },
    },
  ];
  allRows.push(dataRow);
  const ws = XLSX.utils.aoa_to_sheet([...allRows]);

  ws["!cols"] = [
    { wch: 22 }, // Width for "Job Title" column
    { wch: 20 }, // Width for "Department" column
    { wch: 15 }, // Width for "Job Code" column
    { wch: 10 }, // Width for "Job Grade" column
    { wch: 25 }, // Width for "Role Type" column
    { wch: 18 }, // Width for "Level of Work" column
    { wch: 10 }, // Width for "Level of Work Modifier" column
    { wch: 10 }, // Width for "Level of Work Points" column
    { wch: 15 }, // Width for "Institutional Expertise & Skill" column
    { wch: 10 }, // Width for "Cultural Impact" column
    { wch: 15 }, // Width for "Physical Environment" column
    { wch: 15 }, // Width for "Mental & Emotional Environment" column
    { wch: 18 }, // Width for "Application of Knowledge & Skill" column
    { wch: 10 }, // Width for "Manual Effort" column
    { wch: 15 }, // Width for "Outcomes" column
    { wch: 30 }, // Width for "Notes" column
    { wch: 10 }, // Width for "RAS Score" column
    { wch: 10 }, // Width for "RAS Level" column
    { wch: 25 }, // Width for "RAS Code" column
    { wch: 15 }, // Width for "Evaluated By" column
    { wch: 15 }, // Width for "Evaluated Date" column
  ];

  ws["!rows"] = [
    { hpx: 30 }, // height of the first row in pixels
    {},
    {},
    {},
    { hpx: 30 },
    { hpx: 70 },
  ];

  ws["!merges"] = [
    { s: { r: 4, c: 8 }, e: { r: 4, c: 9 } }, //Merge Column 8 & 9
    { s: { r: 4, c: 10 }, e: { r: 4, c: 11 } }, //Merge Column 10 & 11
    { s: { r: 4, c: 0 }, e: { r: 5, c: 0 } },
    { s: { r: 4, c: 1 }, e: { r: 5, c: 1 } },
    { s: { r: 4, c: 2 }, e: { r: 5, c: 2 } },
    { s: { r: 4, c: 3 }, e: { r: 5, c: 3 } },
    { s: { r: 4, c: 4 }, e: { r: 5, c: 4 } },
    { s: { r: 4, c: 5 }, e: { r: 5, c: 5 } },
    { s: { r: 4, c: 6 }, e: { r: 5, c: 6 } },
    { s: { r: 4, c: 7 }, e: { r: 5, c: 7 } },
    { s: { r: 4, c: 12 }, e: { r: 5, c: 12 } },
    { s: { r: 4, c: 13 }, e: { r: 5, c: 13 } },
    { s: { r: 4, c: 14 }, e: { r: 5, c: 14 } },
    { s: { r: 4, c: 15 }, e: { r: 5, c: 15 } },
    { s: { r: 4, c: 16 }, e: { r: 5, c: 16 } },
    { s: { r: 4, c: 17 }, e: { r: 5, c: 17 } },
    { s: { r: 4, c: 18 }, e: { r: 5, c: 18 } },
    { s: { r: 4, c: 19 }, e: { r: 5, c: 19 } },
    { s: { r: 4, c: 20 }, e: { r: 5, c: 20 } },
  ];

  const wb = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, ws, "Evaluation");

  // STEP 4: Write Excel file to browser
  XLSX.writeFile(wb, "Evaluation.xlsx");
};
